// extracted by mini-css-extract-plugin
module.exports = {"Btn":"Button_Btn__OiLsN"};